import { render, staticRenderFns } from "./platformPie.vue?vue&type=template&id=51f3cf1b&scoped=true&"
import script from "./platformPie.vue?vue&type=script&lang=js&"
export * from "./platformPie.vue?vue&type=script&lang=js&"
import style0 from "./platformPie.vue?vue&type=style&index=0&id=51f3cf1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f3cf1b",
  null
  
)

export default component.exports